export const setCart = (state, payload) => {
  state.campsiteBookings = payload.campsiteBookings
  state.parkingBookings = payload.parkingBookings
  state.gatePasses = payload.gatePasses
  state.otherCharges = payload.otherCharges
}
